import { combineReducers } from 'redux'
import calendar from './calendar'
export default combineReducers({
  calendar,
})
